import React from "react";

// 支持的时钟图标类型
// export type ClockModeIconType = "clock" | "clock-outline" | "clock-filled";

export interface ClockModeIconProps {
  type?: string;
  size?: number | string;
  color?: string;
  className?: string;
}

/**
 * 通用时钟模式图标组件
 * 复用 SVG sprite，支持多种样式
 */
const ClockModeIcon: React.FC<ClockModeIconProps> = ({
  type = "clock",
  size = 24,
  color = "currentColor",
  className = "",
}) => {
  // 兼容数字和字符串
  const iconSize = typeof size === "number" ? `${size}px` : size;
  return (
    <svg
      className={`clock-mode-icon ${className}`}
      width={iconSize}
      height={iconSize}
      style={{ color }}
      aria-hidden="true"
    >
      {/* 使用 SVG sprite */}
      <use xlinkHref={`#cmi-${type}`} />
    </svg>
  );
};

export default ClockModeIcon;
